const ORG_ADMIN_ONLY_SCREEN_TYPES = [
	'HRIS_CONNECTORS',
	'TEAM_TYPES',
	'TEAM_TYPES_CREATE',
	'TEAM_TYPES_EDIT',
	'CUSTOM_FIELDS',
] as const;

export const ScreenTypes: readonly [
	'HRIS_CONNECTORS',
	'TEAM_TYPES',
	'TEAM_TYPES_CREATE',
	'TEAM_TYPES_EDIT',
	'CUSTOM_FIELDS',
	'NOTIFICATIONS',
] = [...ORG_ADMIN_ONLY_SCREEN_TYPES, 'NOTIFICATIONS'] as const;

export type ScreenType = (typeof ScreenTypes)[number];

export const DEFAULT_TEAM_SCREEN: ScreenType = 'HRIS_CONNECTORS';
export const DEFAULT_TEAM_SCREEN_NEXT: ScreenType = 'TEAM_TYPES';

export const isOrgAdminOnlyScreenType = (screenType: ScreenType): boolean => {
	return ORG_ADMIN_ONLY_SCREEN_TYPES.includes(
		screenType as (typeof ORG_ADMIN_ONLY_SCREEN_TYPES)[number],
	);
};
